// import { useState, useMemo } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardHeader, CardFooter } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import NeatixModal from '@components/Modal/NeatixModal';
// import AddCreateAccountApPayments from './AddCreateAccountApPayments';
// import useGetPaymentsList from '@hooks/Finance/ApPayments/useGetPaymentsList';
// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import Pagination from '@components/Shared/Pagination/Pagination';
// import { paymentTypeEnum } from '../paymentTypeEnum';

// const ListApPayments = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [selectedApPayments, setSelectedApPayments] = useState<any[]>([]);

//   // ✅ حالة الفلاتر الجديدة
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   // ✅ حالة Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [dataPerPage, setDataPerPage] = useState(15);

//   const { t, i18n } = useTranslation();
//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();
//   const { ApPaymentsList: data, loading, error } = useGetPaymentsList();

//   // ✅ تصفية البيانات بناءً على الفلاتر
//   const filteredData = useMemo(() => {
//     let filtered = data?.filter(f => !f.postedFlag && f.status !== 'cancelled') || [];

//     if (supplierFilter) {
//       filtered = filtered.filter(item => item.peopleId === supplierFilter.value);
//     }

//     if (organizationFilter) {
//       filtered = filtered.filter(item => item.organizationId === organizationFilter.value);
//     }

//     if (dateFrom) {
//       filtered = filtered.filter(item => new Date(item.paymentDate) >= new Date(dateFrom));
//     }

//     if (dateTo) {
//       filtered = filtered.filter(item => new Date(item.paymentDate) <= new Date(dateTo));
//     }

//     // حساب عدد الفلاتر النشطة
//     const count = [supplierFilter ? 1 : 0, organizationFilter ? 1 : 0, dateFrom ? 1 : 0, dateTo ? 1 : 0].reduce(
//       (a, b) => a + b,
//       0
//     );

//     setActiveFiltersCount(count);
//     setCurrentPage(1); // إعادة تعيين الصفحة إلى الأولى عند تغيير الفلاتر

//     return filtered;
//   }, [data, supplierFilter, organizationFilter, dateFrom, dateTo]);

//   // ✅ حساب البيانات المعروضة للصفحة الحالية
//   const displayedData = useMemo(() => {
//     const startIndex = (currentPage - 1) * dataPerPage;
//     const endIndex = startIndex + dataPerPage;
//     return filteredData.slice(startIndex, endIndex);
//   }, [filteredData, currentPage, dataPerPage]);

//   const handleCheckboxChange = (item: any) => {
//     setSelectedApPayments(prevSelected => {
//       const isSelected = prevSelected?.some(selected => selected.id === item.id);

//       if (isSelected) {
//         return prevSelected?.filter(selected => selected.id !== item.id);
//       } else {
//         return [...prevSelected, item];
//       }
//     });
//   };

//   const handleSelectAll = () => {
//     // اختيار جميع البيانات المعروضة فقط
//     if (selectedApPayments.length === displayedData.length) {
//       setSelectedApPayments([]);
//     } else {
//       setSelectedApPayments([...displayedData]);
//     }
//   };

//   const handleSelectAllFiltered = () => {
//     // اختيار جميع البيانات بعد التصفية
//     if (selectedApPayments.length === filteredData.length) {
//       setSelectedApPayments([]);
//     } else {
//       setSelectedApPayments([...filteredData]);
//     }
//   };

//   const handleOpenAddCreateAccount = () => {
//     if (selectedApPayments?.length > 0) {
//       setShowModal(true);
//     }
//   };

//   // ✅ دالة Pagination
//   const handlePagination = (page: number) => {
//     setCurrentPage(page);
//   };

//   // دالة لتنسيق المبلغ
//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   // دالة تحويل نوع الدفع إلى Badge مع أيقونة

//   const getPaymentTypeDisplay = (type: string, name: string) => {
//     switch (type) {
//       case paymentTypeEnum.Standard:
//         return (
//           <span className={`badge bg-primary `} title={name}>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             قياسي
//           </span>
//         );
//       case paymentTypeEnum.PrePayment:
//         return (
//           <span className={`badge bg-success `} title={name}>
//             <i className='fas fa-hand-holding-usd me-1'></i>
//             مقدمة
//           </span>
//         );
//       case paymentTypeEnum.Refund:
//         return (
//           <span className={`badge bg-danger `} title={name}>
//             <i className='fas fa-rotate-left me-1'></i>
//             استرداد
//           </span>
//         );
//       case paymentTypeEnum.ApplyPrePayment:
//         return (
//           <span className={`badge bg-info text-dark `} title={name}>
//             <i className='fas fa-link me-1'></i>
//             تطبيق مقدمة
//           </span>
//         );
//       case paymentTypeEnum.ApplyDebitMemo:
//         return (
//           <span className={`badge bg-warning text-dark `} title='تطبيق إشعار مدين'>
//             <i className='fas fa-file-invoice me-1'></i>
//             تطبيق مدين
//           </span>
//         );
//       default:
//         return (
//           <span className={`badge bg-secondary `} title={name}>
//             <i className='fas fa-question-circle me-1'></i>
//             {name}
//           </span>
//         );
//     }
//   };

//   const getPostedFlagBadge = (flag: boolean) =>
//     flag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i>
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i>
//         {t('NotPosted')}
//       </span>
//     );

//   const breadcrumbList = [
//     { name: t('Home'), link: '/AP/HomePage' },
//     { name: t('PostPaymentVouchers'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PostPaymentVouchers')} />

//         <div className='ms-auto d-flex gap-2'>
//           {/* <button
//             type='button'
//             className='btn btn-outline-theme'
//             onClick={handleSelectAllFiltered}
//             disabled={filteredData.length === 0}
//           >
//             <i className='fas fa-check-square me-1'></i>
//             {selectedApPayments.length === filteredData.length ? t('DeselectAll') : t('SelectAll')}
//           </button> */}

//           <button
//             type='button'
//             className='btn btn-theme'
//             onClick={handleOpenAddCreateAccount}
//             disabled={selectedApPayments.length === 0}
//           >
//             <i className='fa fa-share-square fa-fw me-1'></i>
//             {t('PostSelectedVouchers')} ({selectedApPayments.length})
//           </button>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* ✅ فلترة بوحدة التشغيل */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <Select
//                   value={organizationFilter}
//                   onChange={setOrganizationFilter}
//                   options={OperatingUnitOptions}
//                   placeholder={t('اختر وحدة تشغيـل')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالمورد */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <Select
//                   value={supplierFilter}
//                   onChange={setSupplierFilter}
//                   options={OptionSuppliers}
//                   placeholder={t('اختر مورد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ من وإلى */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('From')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input
//                   type='date'
//                   className='form-control'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                   placeholder={t('To')}
//                 />
//               </div>
//             </div>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-25 fw-bold'>
//                 <tr>
//                   <th className='small text-center'>
//                     <div className='form-check'>
//                       <input
//                         type='checkbox'
//                         className='form-check-input'
//                         checked={
//                           displayedData.length > 0 &&
//                           selectedApPayments.length === displayedData.length &&
//                           displayedData.every(item => selectedApPayments.some(selected => selected.id === item.id))
//                         }
//                         onChange={handleSelectAll}
//                       />
//                     </div>
//                   </th>
//                   <th className='small'>{t('VoucherNumber')}</th>
//                   <th className='small'>{t('Supplier')}</th>
//                   <th className='small'>{t('Date')}</th>
//                   <th className='small'>{t('Amount')}</th>
//                   <th className='small text-center'>{t('PostingStatus')}</th>
//                   <th className='small'>{t('PaymentType')}</th>
//                   <th className='small'>{t('وحدة التشغيل')}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayedData.length > 0 ? (
//                   displayedData.map((item: any) => {
//                     const TypeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;

//                     return (
//                       <tr key={item.id}>
//                         <td className='align-middle text-center'>
//                           <div className='form-check'>
//                             <input
//                               type='checkbox'
//                               className='form-check-input'
//                               checked={selectedApPayments.some(selected => selected.id === item.id)}
//                               onChange={() => handleCheckboxChange(item)}
//                             />
//                           </div>
//                         </td>
//                         <td className='align-middle'>
//                           <strong className='text-theme'>{item.code}</strong>
//                         </td>
//                         <td className='align-middle'>
//                           <div className='d-flex flex-column'>
//                             <strong className='fw-bold'>
//                               {i18n.language === 'en' ? item.peopleName : item.peopleName2}
//                             </strong>
//                             {item.peopleCode && (
//                               <small className='text-muted'>
//                                 {t('Code')}: {item.peopleCode}
//                               </small>
//                             )}
//                           </div>
//                         </td>
//                         <td className='align-middle'>{item.paymentDate.split('T')[0]}</td>
//                         <td className='align-middle'>
//                           <span className='fw-bold text-theme'>{formatAmount(item.amount)}</span>
//                         </td>
//                         <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
//                         <td className='align-middle'>{getPaymentTypeDisplay(item.paymentType, TypeName)}</td>
//                         <td className='align-middle'>
//                           {i18n.language === 'en' ? item.organizationName : item.organizationName2}
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={8} className='text-center py-4 text-muted'>
//                       <i className='fa fa-inbox fa-2x mb-2'></i>
//                       <br />
//                       {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoVouchersRegistered')}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex align-items-center gap-3'></div>
//           {/* Pagination Component */}
//           <Pagination
//             filteredData={filteredData}
//             dataPerPage={dataPerPage}
//             handlePagination={handlePagination}
//             currentPage={currentPage}
//           />
//         </CardFooter>
//       </Card>

//       <NeatixModal show={showModal} setShow={setShowModal} size='xl' showHeader={false} backdrop>
//         {selectedApPayments?.length > 0 && (
//           <AddCreateAccountApPayments
//             selectedApPayments={selectedApPayments}
//             onClose={() => {
//               setShowModal(false);
//               setSelectedApPayments([]);
//               // يمكنك إضافة refetch هنا إذا كنت بحاجة لإعادة تحميل البيانات
//             }}
//           />
//         )}
//       </NeatixModal>
//     </>
//   );
// };

// export default ListApPayments;


import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardHeader, CardFooter } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import AddCreateAccountApPayments from './AddCreateAccountApPayments';
import Select from 'react-select';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';

import { paymentTypeEnum } from '../paymentTypeEnum';

const TABLE_KEY = 'ApPayments_unPosted_Index';

const ListApPayments = () => {
  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);

  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  const [showModal, setShowModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  // ✅ Selection across pages
  const [selectedMap, setSelectedMap] = useState<Record<string, any>>({});

  // ✅ Inline filters
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers } = useGetSuppliersList();

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApPaymentsListUnposted_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  const selectedApPayments = useMemo(() => Object.values(selectedMap), [selectedMap]);

  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const applyFilters = () => {
    const newFilters: any[] = [];

    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0, // OpEquals
        value: supplierFilter.value
      });
    }

    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0, // OpEquals
        value: organizationFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentDate',
        operator: 3, // OpGreaterOrEqual
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentDate',
        operator: 5, // OpLessOrEqual
        value: dateTo
      });
    }

    // ✅ (اختياري) استبعاد cancelled لو الendpoint ما يستبعده
    // ⚠️ يعتمد على وجود OpNotEquals = 1 في نظام الفلاتر عندك
    // newFilters.push({
    //   id: generateFilterId(),
    //   field: 'status',
    //   operator: 1, // OpNotEquals (اذا عندكم)
    //   value: 'cancelled'
    // });

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    setSelectedMap({});
  };

  const clearFilters = () => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    setSelectedMap({});
  };

  const handleCheckboxChange = (item: any) => {
    setSelectedMap(prev => {
      const next = { ...prev };
      if (next[item.id]) delete next[item.id];
      else next[item.id] = item;
      return next;
    });
  };

  const isAllPageSelected = data.length > 0 && data.every((x: any) => !!selectedMap[x.id]);

  const handleSelectAllPage = () => {
    setSelectedMap(prev => {
      const next = { ...prev };

      if (isAllPageSelected) {
        data.forEach((x: any) => {
          if (next[x.id]) delete next[x.id];
        });
      } else {
        data.forEach((x: any) => {
          next[x.id] = x;
        });
      }

      return next;
    });
  };

  const handleOpenAddCreateAccount = () => {
    if (selectedApPayments.length > 0) setShowModal(true);
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  const getPaymentTypeDisplay = (type: string, name: string) => {
    switch (type) {
      case paymentTypeEnum.Standard:
        return (
          <span className='badge bg-primary' title={name}>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            قياسي
          </span>
        );
      case paymentTypeEnum.PrePayment:
        return (
          <span className='badge bg-success' title={name}>
            <i className='fas fa-hand-holding-usd me-1'></i>
            مقدمة
          </span>
        );
      case paymentTypeEnum.Refund:
        return (
          <span className='badge bg-danger' title={name}>
            <i className='fas fa-rotate-left me-1'></i>
            استرداد
          </span>
        );
      case paymentTypeEnum.ApplyPrePayment:
        return (
          <span className='badge bg-info text-dark' title={name}>
            <i className='fas fa-link me-1'></i>
            تطبيق مقدمة
          </span>
        );
      case paymentTypeEnum.ApplyDebitMemo:
        return (
          <span className='badge bg-warning text-dark' title='تطبيق إشعار مدين'>
            <i className='fas fa-file-invoice me-1'></i>
            تطبيق مدين
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary' title={name}>
            <i className='fas fa-question-circle me-1'></i>
            {name}
          </span>
        );
    }
  };

  // ✅ Advanced filter fields (السلايدر)
  const paymentTypeOptions = [
    { value: paymentTypeEnum.Standard, label: 'قياسي' },
    { value: paymentTypeEnum.PrePayment, label: 'مقدمة' },
    { value: paymentTypeEnum.Refund, label: 'استرداد' },
    { value: paymentTypeEnum.ApplyPrePayment, label: 'تطبيق مقدمة' },
    { value: paymentTypeEnum.ApplyDebitMemo, label: 'تطبيق إشعار مدين' }
  ];

  const fields: any = [
    { name: 'code', label: t('VoucherNumber'), type: 'string' },
    { name: 'paymentDate', label: t('Date'), type: 'date' },
    { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'paymentType', label: t('PaymentType'), type: 'options', options: paymentTypeOptions },
    { name: 'postedFlag', label: t('PostingStatus'), type: 'options', options: [{ value: true, label: t('Posted') }, { value: false, label: t('NotPosted') }] }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: '/AP/HomePage' },
    { name: t('PostPaymentVouchers'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PostPaymentVouchers')} />

        <div className='ms-auto d-flex gap-2'>
          <button
            type='button'
            className='btn btn-theme'
            onClick={handleOpenAddCreateAccount}
            disabled={selectedApPayments.length === 0}
          >
            <i className='fa fa-share-square fa-fw me-1'></i>
            {t('PostSelectedVouchers')} ({selectedApPayments.length})
          </button>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* OU */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Supplier */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Date range */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className='col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('SearchFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              {/* ✅ ترتيب أعمدة أمثل للسندات */}
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small text-center'>
                    <div className='form-check'>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        checked={isAllPageSelected}
                        onChange={handleSelectAllPage}
                      />
                    </div>
                  </th>
                  <th className='small'>{t('VoucherNumber')}</th>
                  <th className='small'>{t('Date')}</th>
                  <th className='small'>{t('Supplier')}</th>
                  <th className='small'>{t('Amount')}</th>
                  <th className='small'>{t('وحدة التشغيل')}</th>
                  <th className='small'>{t('PaymentType')}</th>
                  <th className='small text-center'>{t('PostingStatus')}</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const typeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;

                    return (
                      <tr key={item.id}>
                        <td className='align-middle text-center'>
                          <div className='form-check'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              checked={!!selectedMap[item.id]}
                              onChange={() => handleCheckboxChange(item)}
                            />
                          </div>
                        </td>

                        <td className='align-middle'>
                          <strong className='text-theme'>{item.code}</strong>
                        </td>

                        <td className='align-middle'>{(item.paymentDate || '').split('T')[0]}</td>

                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <strong className='fw-bold'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</strong>
                            {item.peopleCode && (
                              <small className='text-muted'>
                                {t('Code')}: {item.peopleCode}
                              </small>
                            )}
                          </div>
                        </td>

                        <td className='align-middle'>
                          <span className='fw-bold text-theme'>{formatAmount(item.amount)}</span>
                        </td>

                        <td className='align-middle'>
                          {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                        </td>

                        <td className='align-middle'>{getPaymentTypeDisplay(item.paymentType, typeName)}</td>

                        <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={8} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoVouchersRegistered')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal show={showModal} setShow={setShowModal} size='xl' showHeader={false} backdrop>
        {selectedApPayments.length > 0 && (
          <AddCreateAccountApPayments
            selectedApPayments={selectedApPayments}
            onClose={() => {
              setShowModal(false);
              setSelectedMap({});
              dispatch(getPagedData({ tableKey: TABLE_KEY }));
            }}
          />
        )}
      </NeatixModal>
    </>
  );
};

export default ListApPayments;
